import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white}`,
    padding: theme.spacing(6, 8),
    marginBottom: theme.spacing(2),
    width: '100%',
    flexGrow: 1,
    // Reskin: a beige inset panel; a white border can't frame anything on the new look's white card.
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  addLabel: {
    marginLeft: theme.spacing(2),
    alignSelf: 'flex-start',
    alignContent: 'flex-start',
    color: theme.colors.header__label_primary,
    width: '100%'
  },
  buttonContainer: {
    padding: theme.spacing(2),
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
